import React, { useEffect, useState } from 'react'
import $ from 'jquery'
import { Box } from '@material-ui/core';
import { APP_SOURCE, IQ_AIR_MODEL, PAGES, STATUS } from '../../utils/constant';
import { getENLMToken, getQueryParam, getValueFromObject, setToLocalStorage, updateAirDeviceInLocalStorage } from '../../utils/utility';
import { setGlobalState, getGlobalState , subscribeGlobalState } from "../../utils/globalState";
import { getENLMTokenFromCookie } from '../../utils/cookies';
import AirDeviceIntegration from '../AirDeviceProvision/airDeviceProvision';
import AirDeviceSetup from '../AirDeviceProvision/setupAirDevice/setupAirDevice';
import IQAirSetting from '../AirSystem/IQAirSetting';
import IQAirScheduler from '../AirSystem/IQAirScheduler';
import AirSystemSetting from '../AirSystem/AirSystemSetting';
import SiteDetails from '../SiteDetails/SiteDetails';
import HvacDetails from '../AirSystem/AirSystemSetting/HvacDetails';
import HvacEnergyMode from '../AirSystem/AirSystemSetting/HvacEnergyMode';
import ConfirmSite from '../AirDeviceProvision/confirmSite/index.js'
import ToastMessage from '../../components/ToastMessage/index.js';
import HCServices from '../../services/hcServices.js';
import Icon from '../../utils/icons.js';
import ErrorCard from '../../components/ErrorCard/index.js';
import { useMobileStyles } from "./styles.js"
import LinkHvacToThermostat from '../AirDeviceProvision/linkHvacToThermostat';

const HomeConnectServices = (props) => {
    const params = getQueryParam(null, true)
    const source = params.source ?? APP_SOURCE.ENHO
    const hcMenu = source === APP_SOURCE.ENL ? params.page ?? PAGES.AIR_SYSTEM_SETTING : props.hcMenu
    const siteInfo = props.siteInfo ?? null
    const iqAirModel = props.iqAirModel ?? params.iqAirModel ?? IQ_AIR_MODEL.IQ_AIR_HUB.ID
    const isOwner = source === APP_SOURCE.ENL ? true : getValueFromObject(props.user_access_roles, 'isOwner')
    const isHost = getValueFromObject(props.user_access_roles, 'isHost')
    const classes = useMobileStyles()
    
    const [pageName, setPageName] = useState('');
    const isWeb = source === APP_SOURCE.ENL ? true : props.isWeb ?? false
    const isDarkMode = props.isDarkMode ?? params.isDarkMode ?? false
    const sessionId = props.sessionId ?? params.sessionId ?? ''
    const ENLMToken = props.ENLMToken ?? getENLMToken() ?? getENLMTokenFromCookie() ?? params.token ?? ''
    const timeZone = props.timeZone ?? ''
    const decode = typeof props.decode === 'function' ? props.decode : null
    const encode = typeof props.encode === 'function' ? props.encode : null
    const updateHeaderText = typeof props.updateHeaderText === 'function' ? props.updateHeaderText: null
    const [siteId, setSiteId] = useState(params.siteId ?? props.siteId)
    const [createNewSite, setCreateNewSite] = useState(false)
    const [airDeviceId, setAirDeviceId] = useState(params.airDeviceId ?? props.airDeviceId)
    const [airDeviceName, setAirDeviceName] = useState(params.airDeviceName ?? props.airDeviceName ?? '')
    const [airUnit, setAirUnit] = useState(params.airUnit ?? props.airUnit ?? 'C')
    const [iqAirId, setIQAirId] = useState(params.iqAirId ?? props.iqAirId ?? '')
    const [toast, setToast] = useState({ status: false, message: '', type: "success" });
    const [loading, setLoading] = useState(false)  
    const [showAPIErrorMsg, setShowAPIErrorMsg] = useState(false)
    const [screenStatus, setScreenStatus] = useState('');
    const [globalLoader, setGlobalLoader] = useState(getGlobalState('initialLoader'));
    const [isHardwareInstallationDone, setIsHardwareInstallationDone] = useState(false);

    useEffect(() => {
    const unsub = subscribeGlobalState((state) => {
        setGlobalLoader(state.initialLoader);
    });
    return unsub;
    }, []);

    useEffect(() => {
        setGlobalState('decodeFn', decode)
    }, [decode])

    useEffect(() => {
        setGlobalState('encodeFn', encode)
    }, [encode])

    useEffect(() => {
        if(props.reRenderHC && isWeb ){
           setPageName(PAGES.AIR_SYSTEM_SETTING) 
           setGlobalState('pageName', PAGES.AIR_SYSTEM_SETTING);
           setAirDeviceId(props.airDeviceId)
           setAirDeviceName(props.airDeviceName)
        }
        else if (hcMenu) {
            setGlobalState('pageName', hcMenu);
            setPageName(hcMenu)
        }             
    }, [hcMenu,props.reRenderHC])

    useEffect(() => {       
        setGlobalState("siteId", siteId)
        setGlobalState("airDeviceName", airDeviceName)
        setGlobalState("airDeviceId", airDeviceId)
        setGlobalState("airUnit", airUnit)
        setGlobalState("iqAirId", iqAirId)
    }, [siteId, airDeviceName,airUnit,airDeviceId, iqAirId]);

    useEffect(() => {
        updateLocalStorage();
    }, [sessionId, isWeb, ENLMToken])

    useEffect(() => {
        if([PAGES.AIR_DEVICES_PROVISION, PAGES.CONFIRM_SITE].includes(pageName)) setCreateNewSite(false)
    }, [pageName])

    useEffect(() => {
        if(source === APP_SOURCE.ENL) $('#root').addClass('enl-iqair-site');
        init()
    }, [])

    const init = async () => {
        if(siteId) {
            if(hcMenu === PAGES.AIR_SYSTEM_SETTING) {
                await fetchAirDeviceById()
            } else if (hcMenu) {
                updatePageOnHcMenu()
            }
        } else {
            if (hcMenu) {
                updatePageOnHcMenu()
            } else {
                setPageName(PAGES.AIR_DEVICES_PROVISION)
            }
        }
    }

    const fetchAirDeviceById = async () => {
        try {
            setLoading(true)
            const response = await HCServices.getAirDeviceById(siteId, airDeviceId)
            if(response.status === STATUS.SUCCESS && response.data.length) {
                updateAirDeviceInLocalStorage(airDeviceId, response.data[0])
                setGlobalState("airDeviceName", response.data[0]?.name)
                setShowAPIErrorMsg(false)
                updatePageOnHcMenu()
                return
            } else {
                throw new Error()
            }
        } catch(error) {
            setShowAPIErrorMsg(true)
            console.error("Error in fetch Air device by Id")
        } finally {
            setLoading(false)
        }
    }

    const redirectToStatus = (siteId, source = '') => {
        if (typeof props.redirectToStatus === 'function') {
            props.redirectToStatus(siteId, source);
        }
    }

    const redirectToProfile = () => {
        if(typeof props.redirectToProfile === "function") {
            props.redirectToProfile()
        }
    } 

    const redirectToTariff = () => {
        if(typeof props.redirectToTariff === "function") {
            props.redirectToTariff()
        }
    } 

    const updateLocalStorage = () => {
        setToLocalStorage("isWeb", isWeb);
        setToLocalStorage("token", ENLMToken);
        setToLocalStorage("timeZone", timeZone)
        setToLocalStorage("session", sessionId)
        setToLocalStorage("hcsource", source)
    }

    const handleClick = (nextPage, source = '', statusScreen) => {                
        if((source === PAGES.IQ_AIR_SETTING || source === PAGES.AIR_DEVICE_INTEGRATION) && props.fromIQAirStatusPage && typeof props.redirectToStatus === 'function') {
            props.redirectToStatus(siteId);
        }
        if(source === PAGES.AIR_SYSTEM_SETTING && props.fromIQAirProfilePage && typeof props.redirectToProfile === 'function') {
            props.redirectToProfile()
        }
         if(source === PAGES.LINK_HVAC_TO_THERMOSTAT && props.fromManageHVACSystem && typeof props.redirectToManageHVACSystem === 'function') {
           props.redirectToManageHVACSystem()
        }
        setPageName((nextPage === PAGES.CONFIRM_SITE && (props.isEvseOnly || props.isPowerPackSiteOnly || !siteId)) ? PAGES.SITE_DETAILS : nextPage);
        if(statusScreen === 'DEVICE_LINKED_SUCCESSFULLY') {
            setIsHardwareInstallationDone(true);
        }
        setScreenStatus(statusScreen);
    }

    const handleBack = () => {
        if (props.onBack) {
            props.onBack();
        }
    };
    const updatePageOnHcMenu = () => {
        switch (hcMenu) {
            case PAGES.SITE_DETAILS:
                setPageName(PAGES.SITE_DETAILS);
                break;
            case PAGES.AIR_DEVICES_PROVISION:
                setPageName(PAGES.AIR_DEVICES_PROVISION);
                break;
            case PAGES.AIR_DEVICE_INTEGRATION:
                setPageName(PAGES.AIR_DEVICE_INTEGRATION);
                break;
            case PAGES.IQ_AIR_SETTING:
                setPageName(PAGES.IQ_AIR_SETTING);
                break;
            case PAGES.AIR_SYSTEM_SETTING:
                setPageName(PAGES.AIR_SYSTEM_SETTING);
                break;
            case PAGES.HVAC_DETAILS:
                setPageName(PAGES.HVAC_DETAILS)
                break;
            case PAGES.HVAC_ENERGY_MODE:
                setPageName(PAGES.HVAC_ENERGY_MODE)
                break;
            default:
                setPageName(hcMenu);
                break;
        }
    };

    const renderLayouts = () => {
        switch (pageName) {
            case PAGES.AIR_DEVICES_PROVISION:
                return <AirDeviceSetup
                    handleClick={handleClick}
                    onGoBack={handleBack}
                    isDarkMode={isDarkMode}
                    siteId={siteId}
                    iqAirModel={iqAirModel}
                />
            case PAGES.CONFIRM_SITE: 
                return <ConfirmSite
                    handleClick={handleClick}
                    isDarkMode={isDarkMode}
                    siteId={siteId}
                    siteInfo={siteInfo}
                    hasAccess = {isOwner || isHost}
                    maskedOwnerEmail={props.maskedOwnerEmail}
                    iqAirModel={iqAirModel}
                />
            case PAGES.SITE_DETAILS:
                return (
                    <SiteDetails
                        handleClick={handleClick}
                        isDarkMode={isDarkMode}
                        siteId={siteId}
                        setCreateNewSite={setCreateNewSite}
                    />
                )
            case PAGES.AIR_DEVICE_INTEGRATION: {
                return <AirDeviceIntegration
                    handleClick={handleClick}
                    isDarkMode={isDarkMode}
                    redirectToStatus={redirectToStatus}
                    siteId={siteId}
                    setToast={setToast}
                    createNewSite={createNewSite}
                    iqAirModel={iqAirModel}
                    screenStatus={screenStatus}
                    onGoBack={handleBack}
                    isPromoPage={props.isPromoPage}
                    isHardwareInstallationPending={props.fromIQAirStatusPage}
                    isHardwareInstallationDone={isHardwareInstallationDone}
                />
            }
            case PAGES.IQ_AIR_SETTING: 
                return <IQAirSetting
                    handleClick={handleClick}
                    isDarkMode={isDarkMode}
                    airDeviceName={airDeviceName}
                    hasAccess = {isOwner || isHost}
                    maskedOwnerEmail={props.maskedOwnerEmail}
                    isWeb={isWeb}
                    updateHeaderText={updateHeaderText}
                    redirectToProfile={redirectToProfile}
                    redirectToTariff={redirectToTariff}
                />
            case PAGES.AIR_SYSTEM_SETTING: 
                return <AirSystemSetting
                    handleClick={handleClick}
                    onGoBack={handleBack}
                    isDarkMode={isDarkMode}
                    airDeviceName={airDeviceName}
                    airDeviceId={airDeviceId}
                    isWeb={isWeb}
                    updateHeaderText={updateHeaderText}
                    source={source}
                />
            case PAGES.HVAC_DETAILS: 
                return <HvacDetails
                    handleClick={handleClick}
                    isDarkMode={isDarkMode}
                    siteId={siteId}
                    airDeviceName={airDeviceName}
                    airDeviceId={airDeviceId}
                    hasAccess = {isOwner || isHost}
                    maskedOwnerEmail={props.maskedOwnerEmail}
                    isWeb={isWeb}
                    updateHeaderText={updateHeaderText}
                />
            case PAGES.HVAC_ENERGY_MODE: 
                return <HvacEnergyMode
                    handleClick={handleClick}
                    isDarkMode={isDarkMode}
                    siteId={siteId}
                    airDeviceName={airDeviceName}
                    airDeviceId={airDeviceId}
                    hasAccess = {isOwner || isHost}
                    maskedOwnerEmail={props.maskedOwnerEmail}
                    isWeb={isWeb}
                />

            case PAGES.LINK_HVAC_TO_THERMOSTAT: 
                return <LinkHvacToThermostat
                    handleClick={handleClick}
                    onGoBack={handleBack}
                    isDarkMode={isDarkMode}
                    siteId={siteId}
                    airDeviceName={airDeviceName}
                    airDeviceId={airDeviceId}
                    hasAccess = {isOwner || isHost}
                    maskedOwnerEmail={props.maskedOwnerEmail}
                    isWeb={isWeb}
                    fromManageHVACSystem={props.fromManageHVACSystem}
                    iqAirModel={iqAirModel}
                />
               case PAGES.IQ_AIR_SCHEDULER:  
               return <IQAirScheduler isDarkMode={isDarkMode} handleClick={handleClick} />
        }
    }
    return (
        <>
        <Box>
            <ToastMessage
                shouldDisplay={toast.status}
                content={toast.message}
                handleClose={() => setToast({ status: false, message: null, type: null })}
                type={toast.type}
                isWeb={props.isWeb}
            />
        </Box>
        {loading || globalLoader ? (
            <Box className={classes.loaderContainer}>
                <Icon src="loaderV4" width={"60px"} height={"60px"} />
            </Box>
        ) : showAPIErrorMsg ? <ErrorCard onGoBack={handleBack} fetchAirDeviceById={fetchAirDeviceById} source={source} />
          : renderLayouts()}
        </>
    )
}

export default HomeConnectServices
